import { useContext } from "react";

import { ApiPagedMetaContext } from "../contexts";

export function useApiPagedMeta() {
  return useContext(ApiPagedMetaContext);
}
